import { Component, OnInit } from '@angular/core';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { AuthService } from '../shared/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OutageNoticeComponent } from '../outage-notice/outage-notice.component';

@Component({
  selector: 'app-forbidden',
  template: `
    <div class="site-logo-double inline-flex-display top-padding-5 layout">
      <img src="assets/img/logo trm1 (1).svg" alt="Maryland State Retirement and Pension System" class="logo-img-style">
      <div class="block-display">
        <div> Employer </div>
        <div> Portal <span class="text-red" *ngIf="currentStage === '5'">(Sandbox)</span></div>
      </div>
    </div>
    <div class="common-bottom-border"></div>
    <div class="row layout" id="middle-content">
      <div class="align-center nova-font-style">
        <div>
          <img src="assets/img/Maryland crab.jpg" class="crab-img" alt="Maryland Crab">
          <div class="img-subtitle">
            <div class="align-center">
              <span>{{message}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})

export class ForbiddenComponent implements OnInit {

  message: any;
  currentStage: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private readConfigService: ReadConfigService) {
  }

  ngOnInit() {
    this.currentStage = this.readConfigService.getCurrentStage();
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    const usererror = this.activatedRoute.snapshot.queryParams.usererror;
    const errorCode = this.activatedRoute.snapshot.queryParams.error;
    const config = this.readConfigService.getForbiddenText();
    if (errorCode === '401') {
      this.message = config.Unauthorized;
    }
    this.message = usererror ? config.UserError : config.Forbidden;
    this.verifyOutage();
  }

  verifyOutage() {
    const outage = sessionStorage.getItem('outage');
    setTimeout(() => {
      if (outage === null) {
        this.verifyOutage();
      } else {
        const outageSettings = this.readConfigService.getOutageScheduledDetails();
        if (outage === 'true' && outageSettings && outageSettings.maintenanceFlag &&
          this.readConfigService.getDarkFeatureFlag(this.readConfigService.getOutageDFName())) {
          sessionStorage.clear();
          this.router.navigate(['/login']);
        } else {
          this.redirectToLogIn();
        }
      }
    }, 2000);
  }

  redirectToLogIn() {
    const loginRedirectTime = this.readConfigService.getLoginRedirectTime();
    setTimeout(() => {
      sessionStorage.setItem('logout', 'true');
      this.authService.logout(false);
      this.authService.redirectLogoutUser();
    }, loginRedirectTime);
  }
}
